'use strict';

/**
 * OAuth privacy-policy consent gate.
 *
 * Intercepts clicks on OAuth provider buttons that carry the `data-oauth-consent`
 * attribute (rendered by oauth.isml only when the `privacyConsentEnabled` site
 * preference is on), shows a modal requiring explicit privacy-policy consent, and
 * only then continues to the provider. The modal gates every social sign-in, so
 * consent is (re)affirmed on each use — nothing is persisted on the profile.
 *
 * Provider-agnostic: the delegated selectors match any `.f-oauth-btn[data-oauth-consent]`,
 * so future providers (Facebook, etc.) are gated with no JS change. Loaded on both
 * the login page (login.js) and the guest-checkout customer step (checkout.js).
 */

var SELECTORS = {
    oauthButton: '.f-oauth-btn[data-oauth-consent]',
    modal: '#oauthConsentModal',
    agreeCheckbox: '#oauth-consent-agree',
    continueButton: '.js-oauth-consent-continue'
};

module.exports = function () {
    // Provider URL stashed from the intercepted button, used on Continue.
    var targetUrl = null;

    // Intercept the OAuth button click and open the consent modal instead of
    // following the link straight to the provider.
    $(document).on('click', SELECTORS.oauthButton, function (e) {
        e.preventDefault();
        targetUrl = this.getAttribute('href');
        $(SELECTORS.modal).modal('show');
    });

    // Enable Continue only while the agreement box is checked.
    $(document).on('change', SELECTORS.agreeCheckbox, function () {
        var checked = $(this).is(':checked');
        $(SELECTORS.continueButton)
            .prop('disabled', !checked)
            .attr('aria-disabled', checked ? 'false' : 'true');
    });

    // On Continue, redirect to the provider.
    $(document).on('click', SELECTORS.continueButton, function () {
        if (!$(SELECTORS.agreeCheckbox).is(':checked') || !targetUrl) {
            return;
        }
        $(this).addClass('is-loading').attr('aria-busy', 'true');
        window.location.href = targetUrl;
    });

    // Reset the modal when it closes so a re-open starts clean.
    $(document).on('hidden.bs.modal', SELECTORS.modal, function () {
        targetUrl = null;
        $(SELECTORS.agreeCheckbox).prop('checked', false);
        $(SELECTORS.continueButton)
            .prop('disabled', true)
            .attr('aria-disabled', 'true')
            .removeClass('is-loading')
            .removeAttr('aria-busy');
    });
};
